import React from 'react'

function UploadPrintReports() {
  return (
    <div>Upload & Print Reports (PDF/Images)</div>
  )
}

export default UploadPrintReports